var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96975 1.22704C3.82914 1.36768 3.75015 1.55841 3.75015 1.75729C3.75015 1.95616 3.82914 2.14689 3.96975 2.28754L7.68224 6.00004L3.96974 9.71254C3.83313 9.85399 3.75753 10.0434 3.75924 10.2401C3.76095 10.4367 3.83982 10.6248 3.97888 10.7639C4.11794 10.903 4.30605 10.9818 4.50269 10.9835C4.69934 10.9853 4.88879 10.9097 5.03024 10.773L9.27299 6.53029C9.4136 6.38964 9.49258 6.19891 9.49258 6.00004C9.49258 5.80116 9.4136 5.61043 9.27299 5.46979L5.03024 1.22704C4.8896 1.08643 4.69887 1.00745 4.49999 1.00745C4.30112 1.00745 4.11039 1.08643 3.96975 1.22704Z",
    fill: "#CBCDCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClose);
export default __webpack_public_path__ + "static/media/arrow-close.e2378a386362a54580538424043661b6.svg";
export { ForwardRef as ReactComponent };